export class Constants {
  static ROLE_SUPER_ADMIN = 1;
  static ROLE_SYSTEM_ADMIN = 2;
  static ROLE_SCHOOL_ADMIN = 3;
  static ROLE_MENTOR = 4;
}



// WEBPACK FOOTER //
// ./src/app/config/constants.ts